import { render, staticRenderFns } from "./DomesticInquiryEdit.vue?vue&type=template&id=b148ac22"
import script from "./DomesticInquiryEdit.vue?vue&type=script&lang=js"
export * from "./DomesticInquiryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports